// extracted by mini-css-extract-plugin
export default {"card":"card_card__tMCdX","top":"card_top__otDL3","b":"card_b__FvDLU"};